// import logo from './logo.svg';

import React, { useRef, useEffect, useState } from 'react';
import { MapContainer, TileLayer, WMSTileLayer, ZoomControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './App.css';
import usdaLogo from './assets/usda.png';
import nasaLogo from './assets/nasa.png';

function App() {
  const center = [39.8283, -98.5795]; // Center coordinates for contiguous USA
  const zoom = 5;
  const URLs = {
    geoserver: 'http://68.109.131.39:8080'
    // geoserver: 'http://localhost:8081' // Replace with your GeoServer URL
  };

const STYLE_BY_YEAR = {
  '2017': 'smarsgroup:tillage_combined_2017',
  '2018': 'smarsgroup:tillage_combined_2018',
  '2019': 'smarsgroup:tillage_combined_2019',
  '2020': 'smarsgroup:tillage_combined_2020',
  '2021': 'smarsgroup:tillage_combined_2021',
};

  // State to manage selected radio option
  // const [selectedStyle, setSelectedStyle] = useState('tillage_2021');
  
  const [selectedYear, setSelectedYear] = useState("2021");

  // const styleName = STYLE_BY_YEAR[selectedYear];
  // // refs for the four parts
  // const wms1Ref = useRef(null);
  // const wms2Ref = useRef(null);
  // const wms3Ref = useRef(null);
  // const wms4Ref = useRef(null);

  // useEffect(() => {
  //   const params = { styles: styleName, TILED: true, _t: Date.now() }; 
  //   // _t acts as a cache-buster so tiles refresh immediately

  //   wms1Ref.current?.setParams(params, false);
  //   wms2Ref.current?.setParams(params, false);
  //   wms3Ref.current?.setParams(params, false);
  //   wms4Ref.current?.setParams(params, false);
  // }, [styleName]);

  const styleName = STYLE_BY_YEAR[selectedYear];
  
  // Ref for the combined WMS layer
  const combinedWmsRef = useRef(null);

  useEffect(() => {
    const params = { styles: styleName, TILED: true, _t: Date.now() }; 
    // _t acts as a cache-buster so tiles refresh immediately
    combinedWmsRef.current?.setParams(params, false);
  }, [styleName]);


  const handleRadioChange = (e) => setSelectedYear(e.target.value);

  return (
    <div className="relative h-screen w-screen">
      <header className="absolute top-0 w-full bg-[#87CEEB] text-black flex items-center justify-center px-4 py-4 shadow-md z-20">
        <div className="flex items-center space-x-4">
          {/* USDA Logo */}
          <img
            src={usdaLogo}
            alt="USDA Logo"
            className="h-16 w-auto"
          />

          {/* Title */}
          <div className="text-2xl font-bold text-center">
            Satellite based Tillage Intensity Product (2017 - 2021)
          </div>

          {/* NASA Logo */}
          <img
            src={nasaLogo}
            alt="NASA Logo"
            className="h-20 w-auto"
          />
        </div>
      </header>
      <MapContainer center={center} zoom={zoom} zoomControl={false}
        className="h-full w-full z-10"
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://carto.com/">CARTO</a>'
          subdomains={["a", "b", "c", "d"]}
        />

        <WMSTileLayer
          ref={combinedWmsRef}
          key={`tillage-map-${selectedYear}`}
          layers={"smarsgroup:tillage_map_all"} 
          url={`${URLs.geoserver}/geoserver/gwc/service/wms`}
          transparent={true}
          format="image/png" 
          opacity={1}
          tileSize={256}
          params= {{ styles: styleName, TILED: true }}
        />
        

        {/* <WMSTileLayer
          ref = {wms1Ref}
          layers={"smarsgroup:us_fb_1"}
          url={`${URLs.geoserver}/geoserver/gwc/service/wms`}
          transparent={true}
          format="image/png8"
          opacity={1}
          tileSize={256}
          params= {{ styles: styleName, TILED: true }}
        />

        <WMSTileLayer
          ref = {wms2Ref}
          layers={"smarsgroup:us_fb_2"}
          url={`${URLs.geoserver}/geoserver/gwc/service/wms`}
          transparent
          format="image/png8"
          opacity={1}
          tileSize={256}
          params= {{ styles: styleName, TILED: true }}
        />

        <WMSTileLayer
          ref = {wms3Ref}
          layers={"smarsgroup:us_fb_3"}
          url={`${URLs.geoserver}/geoserver/gwc/service/wms`}
          transparent={true}
          format="image/png8"
          opacity={1}
          tileSize={256}
          params= {{ styles: styleName, TILED: true }}
        />

        <WMSTileLayer
          ref = {wms4Ref}
          layers={"smarsgroup:us_fb_4"}
          url={`${URLs.geoserver}/geoserver/gwc/service/wms`}
          transparent={true}
          format="image/png8"
          opacity={1}
          tileSize={256}
          params= {{ styles: styleName, TILED: true }}
        /> */}
        
        
        <WMSTileLayer
          // key={`state-boundaries-${selectedStyle}`}
          layers="topp:states" // GeoServer layer name
          url={`${URLs.geoserver}/geoserver/wms`}
          transparent={true}
          styles='us_state_boundary'
          format="image/png"
          params={{
            CQL_FILTER: "STATE_ABBR IS NOT NULL",
            BGCOLOR: '0xFFFFFF'
          }}
          tileSize={256}
          opacity={0.5}
        />
        <ZoomControl position='bottomleft' />
      </MapContainer>

      {/* Legend */}
      <div className="absolute bottom-4 right-4 bg-white p-4 rounded shadow-lg z-20">
        <h3 className="text-lg font-bold mb-2">Legend</h3>
        <div className="flex items-center mb-1">
          <span className="w-4 h-4 bg-red-500 rounded-full inline-block mr-2"></span>
          <span>Intensive Tillage</span>
        </div>
        <div className="flex items-center mb-1">
          <span className="w-4 h-4 bg-yellow-500 rounded-full inline-block mr-2"></span>
          <span>Reduced Tillage</span>
        </div>
        <div className="flex items-center">
          <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
          <span>Conservation Tillage</span>
        </div>
        <div className="flex items-center">
          <span className="w-4 h-4 bg-blue-500 rounded-full inline-block mr-2"></span>
          <span>No Tillage</span>
        </div>
      </div>

      <div className="absolute bottom-3 left-80 z-20 bg-white p-4 rounded shadow-lg">
        <h3 className="text-lg font-bold mb-2">For Details</h3>
        <p>Contact: <a href="mailto:Prasad.Bandaru@usda.gov" className="text-blue-500 underline">Prasad.Bandaru@usda.gov</a></p>
      </div>

      {/* Options */}
      {/* Radio Options */}
      <div className="absolute bottom-3 left-20 z-20 bg-white p-4 rounded shadow-lg">
        <h3 className="text-lg font-bold mb-2">Options</h3>
        <form>
          {["2017", "2018", "2019", "2020", "2021"].map((year) => (
            <div className="mb-2" key={year}>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="year"
                  value={year}
                  className="form-radio"
                  checked={selectedYear === year}
                  onChange={handleRadioChange}
                />
                <span className="ml-2">{year}</span>
              </label>
            </div>
          ))}
        </form>
      </div>
    </div>

  );
}

export default App;
